import Header from "app/pages/Header/Header";

const BrandHeader = props => <Header {...props} />;
export default BrandHeader;
